(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-header';
  var DESKTOP_BP = 990;

  function initSection(header) {
    if (!header || header.dataset.odditInit === 'true') return;
    header.dataset.odditInit = 'true';

    var megaMenu = header.querySelector('[data-mega-menu-panel]');
    var overlay = header.querySelector('[data-mega-menu-overlay]');
    var megaTriggers = header.querySelectorAll('[data-mega-menu-trigger]');
    var mobileToggle = header.querySelector('[data-mega-menu-mobile-toggle]');
    var accordions = header.querySelectorAll('[data-accordion]');

    var activeTrigger = null;
    var megaCloseTimer = null;
    var isMobile = window.innerWidth < DESKTOP_BP;

    function isHoverPointer(e) {
      return e.pointerType === 'mouse' || e.pointerType === 'pen';
    }

    function isMobileView() {
      return window.innerWidth < DESKTOP_BP;
    }

    /* ------------------------------------------------------------
     * MEGA MENU OPEN / CLOSE
     * ---------------------------------------------------------- */
    function openMegaMenu(label) {
      if (!megaMenu) return;

      // For desktop: show the panel matching the label
      if (!isMobileView()) {
        var panels = megaMenu.querySelectorAll('[data-mega-menu-label]');
        if (panels.length === 0) {
          // No per-label panels — show whole desktop area
        } else {
          for (var i = 0; i < panels.length; i++) {
            if (panels[i].dataset.megaMenuLabel === label) {
              panels[i].style.display = '';
            } else {
              panels[i].style.display = 'none';
            }
          }
        }
      }

      megaMenu.classList.add('is-open');
      megaMenu.setAttribute('aria-hidden', 'false');

      if (overlay) overlay.classList.add('is-visible');
      document.body.classList.add('oddit-header-menu-open');
    }

    function closeMegaMenu() {
      if (!megaMenu) return;
      megaMenu.classList.remove('is-open');
      megaMenu.setAttribute('aria-hidden', 'true');

      for (var i = 0; i < megaTriggers.length; i++) {
        megaTriggers[i].setAttribute('aria-expanded', 'false');
      }
      if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
      activeTrigger = null;

      if (overlay) overlay.classList.remove('is-visible');
      document.body.classList.remove('oddit-header-menu-open');
    }

    function openMegaMenuFor(trigger) {
      clearTimeout(megaCloseTimer);
      var label = trigger.getAttribute('data-mega-menu-label');
      for (var j = 0; j < megaTriggers.length; j++) {
        megaTriggers[j].setAttribute('aria-expanded', 'false');
      }
      trigger.setAttribute('aria-expanded', 'true');
      activeTrigger = trigger;
      openMegaMenu(label);
    }

    function scheduleCloseMegaMenu() {
      clearTimeout(megaCloseTimer);
      megaCloseTimer = setTimeout(function () { closeMegaMenu(); }, 180);
    }

    /* ------------------------------------------------------------
     * DESKTOP HOVER + CLICK TRIGGERS
     * ---------------------------------------------------------- */
    for (var t = 0; t < megaTriggers.length; t++) {
      (function (trigger) {
        var wrapper = trigger.closest('.oddit-header__link-wrapper') || trigger.parentElement;

        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          if (isMobileView()) return; // mobile uses different toggle
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            closeMegaMenu();
          } else {
            openMegaMenuFor(trigger);
          }
        });

        if (wrapper) {
          wrapper.addEventListener('pointerenter', function (e) {
            if (!isHoverPointer(e)) return;
            if (isMobileView()) return;
            openMegaMenuFor(trigger);
          });
          wrapper.addEventListener('pointerleave', function (e) {
            if (!isHoverPointer(e)) return;
            if (isMobileView()) return;
            scheduleCloseMegaMenu();
          });
        }
      })(megaTriggers[t]);
    }

    if (megaMenu) {
      megaMenu.addEventListener('pointerenter', function (e) {
        if (!isHoverPointer(e)) return;
        if (isMobileView()) return;
        clearTimeout(megaCloseTimer);
      });
      megaMenu.addEventListener('pointerleave', function (e) {
        if (!isHoverPointer(e)) return;
        if (isMobileView()) return;
        scheduleCloseMegaMenu();
      });
    }

    /* ------------------------------------------------------------
     * MOBILE TOGGLE
     * ---------------------------------------------------------- */
    if (mobileToggle) {
      mobileToggle.addEventListener('click', function () {
        var isOpen = mobileToggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closeMegaMenu();
        } else {
          mobileToggle.setAttribute('aria-expanded', 'true');
          openMegaMenu(null);
        }
      });
    }

    /* ------------------------------------------------------------
     * MOBILE ACCORDIONS
     * ---------------------------------------------------------- */
    accordions.forEach(function (accordion) {
      var trigger = accordion.querySelector('[data-accordion-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var isOpen = accordion.classList.contains('is-open');
        if (isOpen) {
          accordion.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          accordion.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* ------------------------------------------------------------
     * OVERLAY CLICK + ESCAPE KEY
     * ---------------------------------------------------------- */
    if (overlay) {
      overlay.addEventListener('click', closeMegaMenu);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && megaMenu && megaMenu.classList.contains('is-open')) {
        closeMegaMenu();
      }
    });

    /* ------------------------------------------------------------
     * RESIZE — close menu on viewport transition
     * ---------------------------------------------------------- */
    window.addEventListener('resize', function () {
      var nowMobile = isMobileView();
      if (nowMobile !== isMobile) {
        isMobile = nowMobile;
        closeMegaMenu();
      }
    });

    /* ------------------------------------------------------------
     * CART DRAWER INTEGRATION
     * ---------------------------------------------------------- */
    var cartToggles = header.querySelectorAll('[data-cart-toggle]');
    for (var i = 0; i < cartToggles.length; i++) {
      cartToggles[i].addEventListener('click', function () {
        if (window.OdditCartDrawer) {
          window.OdditCartDrawer.open();
        }
      });
    }
  }

  /* --------------------------------------------------------------
   * GLOBAL: Live cart count badge
   * ------------------------------------------------------------ */
  document.addEventListener('cart:updated', function (e) {
    if (!e.detail || !e.detail.cart) return;
    var cart = e.detail.cart;
    var badges = document.querySelectorAll('.oddit-header__cart-count');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = cart.item_count;
      badges[i].style.display = cart.item_count > 0 ? '' : 'none';
    }
  });

  /* --------------------------------------------------------------
   * INIT + Shopify section reload
   * ------------------------------------------------------------ */
  function initAll() {
    var headers = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < headers.length; i++) initSection(headers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var header = e.target.querySelector(SECTION_SELECTOR);
    if (header) initSection(header);
  });
})();